import moment from 'moment'

export default {
    intervalExists: function() {
        const self = this

        let result = true

        self.event.dates.forEach(date => {
            if (! self.validateDate(date.startDate)) {
                result = false
            }
        })

        return result
    },
    intervalIsNormalized: function() {
        const self = this
        let firstDate = moment(self.parseDate(self.event.dates[0].startDate)),
            lastDate = moment(self.parseDate(self.event.dates[self.event.dates.length-1].startDate)),
            diff = lastDate.diff(firstDate, 'days')

        return (diff <= 1) || (diff + 1 === self.event.dates.length)
    },
    hasGapBetweenDays: function() {
        const self = this

        let currentDate = null,
            hasGap = false

        self.event.dates.forEach(date => {
            if (currentDate) {
                if (moment(date.startDate).isValid() && moment(date.startDate).diff(currentDate, 'days') > 1) {
                    hasGap = true
                }
            }

            currentDate = moment(date.startDate)
        })

        return hasGap
    },
    canSendInvites: function () {
        const self = this

        return self.$store.state.profileSearches && self.$store.state.profileSearches?.length && self.$store.state.profileSearches.filter(profileSearch => {
            return profileSearch && profileSearch.profiles && profileSearch.profiles.length > 0 && !profileSearch.profiles.filter(profile => {
                return !profile.id
            }).length
        }).length === self.event.profileSearches.length
    },
    canAppendProfessionalSearch() {
        const self = this

        let incompleteProfileSearches = []

        if (self.event.profileSearches) {
            incompleteProfileSearches = self.event.profileSearches.filter(profileSearch => {
                if (self.$store.state.profileSearches[profileSearch.id]) {
                    return self.$store.state.profileSearches[profileSearch.id]?.profiles.length < profileSearch.quantity || self.$store.state.profileSearches[profileSearch.id]?.profiles.filter(profile => {return !profile.id}).length
                }
                return true
            })
        }

        return incompleteProfileSearches.length === 0
    },
    isCloning() {
        return this.$route.name === 'ContractorCloneEventForm'
    },
    minimumFee() {
        const setting = this.$store.state.settings?.find(setting => setting.id === 'minimum_fee')
        return setting ? parseFloat(setting.value) : 0
    },
}
